import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { PageHeader, Spinner } from "@/components/common";
import { AiUsage, FactCheckRules, ModelSettings } from "@/components/admin/FactCheckSettings";
import { EvidenceSources, FactDatabase, FactQueue } from "@/components/admin/FactDatabase";

export default function AdminFactCheck() {
  const [d, setD] = useState(null);
  const load = () => api.get("/admin/factcheck/settings").then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);
  if (!d) return <Spinner />;
  const save = async (body, msg = "Settings saved") => {
    try { const { data } = await api.put("/admin/factcheck/settings", body); setD(data); toast.success(msg); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-10" data-testid="admin-factcheck-page">
      <PageHeader env="admin" title="Fact-check & AI costs" subtitle="Cheap rules first, a reusable fact database second, and the capable model only for new, material claims that are risky or spreading." />
      <AiUsage d={d} />
      <ModelSettings ai={d.ai} onSave={(ai) => save({ ai })} />
      <FactCheckRules s={d.settings} topics={d.topics} onSave={(factcheck) => save({ factcheck })} />
      <EvidenceSources sources={d.sources} selected={d.settings.evidence_sources} onSave={(ids) => save({ factcheck: { evidence_sources: ids } }, "Evidence sources saved")} />
      <FactQueue onChange={load} />
      <FactDatabase />
    </div>
  );
}
